import { toast } from 'sonner';

/**
 * Show celebratory toasts for XP gains, rank ups, and achievements.
 * xpResult shape: { xp_gained, new_xp, old_rank, new_rank, new_achievements, rank_up }
 */
export const showXpToasts = (xpResult, { refreshUser } = {}) => {
  if (!xpResult) return;
  if (xpResult.xp_gained > 0) {
    toast.success(`+${xpResult.xp_gained} XP · Total ${xpResult.new_xp} XP`, { duration: 5000 });
  }
  if (xpResult.rank_up) {
    toast.success(`🎉 Rank Up! You're now ${xpResult.new_rank}`, { duration: 7000 });
  }
  if (xpResult.new_achievements?.length) {
    xpResult.new_achievements.forEach((ach) => {
      toast.success(`🏆 Achievement: ${ach}`, { duration: 6000 });
    });
  }
  if (xpResult.new_rank === 'Master' && xpResult.rank_up) {
    toast.success('🇮🇳 Indian Stock Market Unlocked!', { duration: 8000 });
  }
  if (refreshUser) setTimeout(() => refreshUser(), 500);
};
